import(/* webpackChunkName: "semantic-theme" */"@semantic-theme").then(()=>{});
import {AUTH_KEY} from "../definitions";

import cuid from "cuid";
import React from 'react'
import { withTranslation } from 'react-i18next';

import { Button } from 'semantic-ui-react'
import styled, { ThemeProvider } from 'styled-components';

import { __ } from '~/i18n'
import AuthClient from "~/auth0";
import { LoggedIn } from '~/components/auth'
import Link from '~/components/link'
import { actions as configActions } from '~/config'
import theme from '~/theme'

import logic, { buttons, text } from './logic'

const LinkContainer = styled.div`
  display: inline-block;
  margin: 0 8px 0 0;
`

class Auth extends React.PureComponent {
  static defaultProps = {
    showRegister: true,
    showLogin: true,
    showLogout: true,
    showLoggedIn: true
  };

  constructor(props) {
    super(props);

    const { auth0Settings, config } = props;

    if (auth0Settings) {
      this.auth = new AuthClient(auth0Settings, config);
    }
  }

  componentDidMount() {
    const { dispatch } = this.props;
    this.auth.lock.on('authenticated', (authResult) => {

      const { auth0Authenticated } = this.props.actions;
      auth0Authenticated(authResult);
    });

    const handler = () => {
      dispatch(configActions.setRedirectUrl(window.location.href));
    };
    this.auth.lock.on('signin submit', handler);
    this.auth.lock.on('signup submit', handler);
  }

  showLogin = (e) => {
    e && e.preventDefault();
    this.auth.lock.show({initialScreen: 'login'});
  };

  showSignup = (e) => {
    e && e.preventDefault();
    this.auth.lock.show({initialScreen: 'signUp'});
  };

  getButton = (content, props) => {
    const { type } = this.props;

    switch(type) {
      case text:
        return <LinkContainer><Link href="#" {...props}>{content}</Link></LinkContainer>;
      default:
        return <Button color={'green'} {...props }>{ content }</Button>;
    }
  };

  render() {
    const { loggedIn, userInfo, auth0Settings, showRegister, showLogin, showLogout, showLoggedIn } = this.props;
    if(auth0Settings) {

      return (
        <div className="gfy-plugin-container">
          {loggedIn && userInfo && showLoggedIn ?
            <div>
              <LoggedIn showLogout={ showLogout }/>
            </div>
            :
            <div>
              {showLogin ?
                this.getButton(__("Log In"), {onClick: this.showLogin})
              : null}
              {showRegister ?
                this.getButton(__("Sign Up"), {onClick: this.showSignup})
              : null}
            </div>
          }
        </div>
      )
    }

    return null;
  }
}


class AuthContainer extends React.PureComponent {

  render() {
    const { auth0Settings } = this.props;
    if(auth0Settings) {
      return (
        <ThemeProvider theme={theme}>
          <Auth {...this.props} />
        </ThemeProvider>
      )
    }

    return null;
  }
}

const DecoratedAuthContainer = withTranslation('cart')(logic(AuthContainer))

DecoratedAuthContainer.defaultProps = Object.create({gfyPlugin: AUTH_KEY}, {
  id: {
    enumerable: true,
    get: () => cuid()
  }
});
export default DecoratedAuthContainer
